import React from 'react'
import { useState } from '@hookstate/core'
import { IconButton, Grid, Tooltip } from '@mui/material'
import { AltRoute } from '@mui/icons-material'
import { useLang } from '../../../../hooks/useLang'
import useDispatchState from '../../stores/DispatchState'
import useSystemState from '~/features/System/stores/SystemState'

interface UnifyButtonProps {
  readonly canDisunify?: boolean
  readonly disunify?: (params) => Promise<void>
}

export default function DisunifyButton(props: UnifyButtonProps) {
  const { windowManager } = useSystemState()
  const { translate } = useLang()

  const handleChange = () => {
    windowManager()['DispatchDisunification'].open.set(
      !windowManager()['DispatchDisunification'].open.get()
    )
  }

  return (
    <Grid item>
      <Tooltip
        title={translate('Disunify Dispatch')}
        placement="right-start"
        componentsProps={{
          tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
        }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton disabled={!props.canDisunify} onClick={handleChange}>
            <AltRoute />
          </IconButton>
        </span>
      </Tooltip>
    </Grid>
  )
}
